import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExcelIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M21.5858 3.30392H13.9882V1.51367L1.5 3.44117V20.3364L13.9882 22.4874V19.8339H21.5858C21.8158 19.8456 22.0412 19.7656 22.2125 19.6116C22.3839 19.4576 22.4872 19.242 22.5 19.0119V4.12517C22.487 3.89527 22.3836 3.67985 22.2123 3.52597C22.041 3.37209 21.8157 3.29226 21.5858 3.30392ZM21.7057 19.1484H13.9628L13.95 17.7317H15.8153V16.0817H13.9357L13.9268 15.1067H15.8153V13.4567H13.9125L13.9035 12.4817H15.8153V10.8317H13.8975V9.85667H15.8153V8.20667H13.8975V7.23167H15.8153V5.58167H13.8975V4.08167H21.7057V19.1484Z",
			fill: "#20744A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.1094 5.58008H16.8672V7.23008H20.1094V5.58008Z",
			fill: "#20744A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.1094 8.20508H16.8672V9.85508H20.1094V8.20508Z",
			fill: "#20744A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.1094 10.8301H16.8672V12.4801H20.1094V10.8301Z",
			fill: "#20744A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.1094 13.457H16.8672V15.107H20.1094V13.457Z",
			fill: "#20744A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.1094 16.082H16.8672V17.732H20.1094V16.082Z",
			fill: "#20744A"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.75909 8.00433L6.36859 7.91208L7.38034 10.6938L8.57584 7.79733L10.1853 7.70508L8.23084 11.6546L10.1853 15.6138L8.48359 15.4991L7.33459 12.4811L6.18484 15.3843L4.62109 15.2463L6.43759 11.7491L4.75909 8.00433Z",
			fill: "white"
		})
	]
});
export default SvgExcelIcon;
